// Add your custom JS here.
// import Shuffle from 'shufflejs';
import popper from '@popperjs/core';
import * as bootstrap from 'bootstrap';
// https://github.com/understrap/understrap/issues/1583
// import Tooltip from 'bootstrap/js/dist/tooltip';


const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));


let lastScrollTop = 0;
const header = document.getElementById("sit_prod_navbar");

window.addEventListener("scroll", function() {
    let currentScroll = window.pageYOffSet || document.documentElement.scrollTop;

    if (currentScroll <= 150) {
        header.classList.add('siit-nav-top');
    } else {
        header.classList.remove('siit-nav-top');
    }
    
    // if (currentScroll > lastScrollTop) {
    //     // Scrolling down
    //     header.style.top = "-84px"; // Adjust this value based on your menu height
    // } else {
    //     // Scrolling up
    //     header.style.top = "0";
    // }
    
    // lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // For Mobile or negative scrolling

}, false);